/*=========================================================================================
	File Name: router.js
	Description: Routes for vue-router. Lazy loading is enabled.
	Object Strucutre:
										path => router path
										name => router name
										component(lazy loading) => component to load
										meta : {
											rule => which user can have access (ACL)
											breadcrumb => Add breadcrumb to specific page
											pageTitle => Display title besides breadcrumb
										}
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
//import auth from '@/auth/authService'
import Store from "./store/store";

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	routes: [

		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: '',
			component: () => import('./layouts/main/Main.vue'),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================
				{
					path: '/',
					redirect: '/dashboard/analytics'
				},
				{
					path: '/dashboard/analytics',
					name: 'dashboard-analytics',
					component: () => import('./views/DashboardAnalytics.vue'),
					meta: {
						rule: 'public'
					},

				},


				// =============================================================================
				// Application Routes
				// =============================================================================


				{
					path: '/customer-list',
					name: 'customer',
					component: () => import('./views/customer/CustomerList.vue'),
					meta: {
						rule: 'admin'
					}
				},
				{
					path: '/storehouse-list',
					name: 'storehouse',
					component: () => import('./views/storehouse/StorehouseList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/stock-list',
					name: 'stock',
					component: () => import('./views/stock/StockList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/order-list',
					name: 'order',
					component: () => import('./views/order/OrderList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/stock-tracking-addnew',
					name: 'stocktrackingaddnew',
					component: () => import('./views/stockTracking/StockTrackingAddNew.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/stock-tracking',
					name: 'stocktracking',
					component: () => import('./views/stockTracking/StockTrackingList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/user',
					name: 'user',
					component: () => import('./views/user/User.vue'),
					meta: {
						rule: 'public'
					}
				},


			]
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: '',
			component: () => import('@/layouts/full-page/FullPage.vue'),
			children: [

				{
					path: '/login',
					name: 'page-login',
					component: () => import('@/views/pages/login/Login.vue'),
					meta: {
						rule: 'public'
					}
				},


			]
		},
		// Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/pages/error-404'
		}
	]
})

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = 'none'
	}
})
/*
router.beforeEach((to, from, next) => {
	firebase.auth().onAuthStateChanged(() => {

		// get firebase current user
		const firebaseCurrentUser = firebase.auth().currentUser

		// if (
		//     to.path === "/pages/login" ||
		//     to.path === "/pages/forgot-password" ||
		//     to.path === "/pages/error-404" ||
		//     to.path === "/pages/error-500" ||
		//     to.path === "/pages/register" ||
		//     to.path === "/callback" ||
		//     to.path === "/pages/comingsoon" ||
		//     (auth.isAuthenticated() || firebaseCurrentUser)
		// ) {
		//     return next();
		// }

		// If auth required, check login. If login fails redirect to login page
		if (to.meta.authRequired) {
			if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
				router.push({ path: '/pages/login', query: { to: to.path } })
			}
		}

		return next()
		// Specify the current path as the customState parameter, meaning it
		// will be returned to the application after auth
		// auth.login({ target: to.path });

	})

})*/

export default router
